import { render, staticRenderFns } from "./AlertBoxOutline.vue?vue&type=template&id=66cb408a&"
import script from "./AlertBoxOutline.vue?vue&type=script&lang=js&"
export * from "./AlertBoxOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports